<template>
    <div>
        <el-form-item
            :class="form.state('logo')"
            class="mb-0"
            label="Logo"
            v-if="!form.no_logo"
        >
            <br />
            <div v-if="logoSrc">
                <img :src="logoSrc" style="height: 100px" />
                <div style="margin-top: -18px" v-if="usingCorporateLogo">
                    (using corporate logo)
                </div>
            </div>
            <input
                @change="onChangeLogo"
                accept="image/*,application/pdf"
                ref="inputLogo"
                style="display: none"
                type="file"
            />
            <el-button-group size="mini">
                <el-button
                    @click="$refs.inputLogo.click()"
                    icon="mdi mdi-camera"
                    size="small"
                    >Upload Logo</el-button
                >
                <el-button
                    @click="removeLogo()"
                    size="small"
                    type="primary"
                    v-if="selectedCorporation && hasCommunityLogo"
                >
                    Use Corporate Logo
                </el-button>
                <el-button
                    @click="removeLogo()"
                    icon="mdi mdi-image-off"
                    size="small"
                    type="danger"
                    v-if="!selectedCorporation && hasCommunityLogo"
                >
                    Remove Logo
                </el-button>
            </el-button-group>
            <form-feedback :form="form" field="logo" />
        </el-form-item>
        <el-form-item :class="form.state('no_logo')">
            <el-checkbox v-model="form.no_logo"> No Logo </el-checkbox>
            <form-feedback :form="form" field="no_logo" />
        </el-form-item>
        <el-form-item :class="form.state('no_calendar_logo')">
            <el-checkbox v-model="form.no_calendar_logo">
                No Logo on Calendar
            </el-checkbox>
            <form-feedback :form="form" field="no_calendar_logo" />
        </el-form-item>
    </div>
</template>

<script>
import { mapState } from "vuex";
import FileUtils from "@/utils/file";

export default {
    props: {
        form: {
            required: true,
            type: Object,
        },
        community: {
            required: false,
            type: Object,
        },
        corporation: {
            required: false,
            type: Object,
        },
    },
    data() {
        return {
            logo_src: null,
        };
    },
    created() {
        if (this.community && this.community.logo) {
            this.logo_src = this.community.logo.url;
        }
    },
    computed: {
        ...mapState(["corporations"]),
        selectedCorporation() {
            return this.corporation
                ? this.corporation
                : this.corporations.data.find(
                      (corp) => corp.id === parseInt(this.form.corporation_id)
                  );
        },
        logoSrc() {
            if (this.logo_src) {
                return this.logo_src;
            }
            if (this.selectedCorporation) {
                return _.get(this.selectedCorporation, "logo.url");
            }
            return null;
        },
        hasCommunityLogo() {
            return this.form.logo || (this.community && this.community.logo);
        },
        usingCorporateLogo() {
            return !this.hasCommunityLogo && this.selectedCorporation;
        },
    },
    methods: {
        removeLogo() {
            this.logo_src = null;
            this.form.logo = null;
            this.form.remove_logo = true;
            if (this.community) {
                this.community.logo = null;
            }
        },
        onChangeLogo(e) {
            let file = _.get(e, "target.files.0");
            if (!file) {
                return;
            }
            FileUtils.checkFileSize(file).then(() => {
                if (FileUtils.isPdf(file)) {
                    this.form.logo = file;
                    this.form.remove_logo = false;
                    this.logo_src = "/images/pdf-icon.svg";
                } else {
                    window.Utils.getFileImageData(e.currentTarget).then(
                        (response) => {
                            this.logo_src = response;
                            this.form.logo = e.target.files[0];
                            this.form.remove_logo = false;
                        }
                    );
                }
            });
        },
    },
};
</script>
